export default __webpack_public_path__ + "static/media/error-dog.7b8bb071.svg";